import React from 'react';
import _ from 'underscore';

export class SpotlightActionList extends React.Component<SpotlightActionList.Props, {}> {

  public static displayName = 'SpotlightActionList';

  public static element = React.createFactory(SpotlightActionList);

  private renderActionIcon(action: SpotlightActionList.SpotlightActionAttributes): React.ReactNode {
    return React.createElement('a', {
      className: 'tb-text-button tb-dark tb-place-action-icon ' + action.iconClass,
      'data-tb-test-id': action.testId,
      href: 'javascript:void(0);', // unactionable href to avoid page reloads/navigation
      key: action.key,
      onClick: action.onClick,// preventDefault in here doesn't appear to stop actioning the href
      tabIndex: 0,
      title: action.title
    } as React.HTMLAttributes<HTMLAnchorElement>);
  }

  public render() {
    const childActions: React.ReactNode[] =
      _.chain(this.props.actions as SpotlightActionList.SpotlightActionAttributes[])
        .map(action => action.isAllowed && this.renderActionIcon(action))
        .compact()
        .value();
    return React.createElement('span', {'data-tb-test-id': 'spotlight-action-list'} as React.HTMLAttributes<HTMLSpanElement>, childActions);
  }
}

export module SpotlightActionList {

  export interface SpotlightActionAttributes {
    onClick: (param: any) => any;
    iconClass: string;
    isAllowed: boolean;
    key: string;
    testId: string;
    title: string;
  }

  export interface Props {
    actions: ReadonlyArray<SpotlightActionList.SpotlightActionAttributes>;
  }

}
